import React from 'react';
import type { CollectionFragment } from '@/utilities/__generated__/graphql';
import { BucketType, createBucketURL } from '@/utilities/createBucketUrl';
import { cleanAddress } from '@/utilities/functions';
import { AvatarShape, AvatarSize } from './Avatar';
import AvatarInfo from './AvatarInfo';

const CollectionInfoCard = ({
  collection,
  count,
  classes = '',
}: {
  collection: CollectionFragment;
  count?: number;
  classes?: string;
}) => {
  const cleanedAddress = cleanAddress(collection.nft_contract_address);
  return (
    <div className={`col-span-1 ${classes}`}>
      <AvatarInfo
        size={AvatarSize.sm}
        shape={AvatarShape.square}
        image={createBucketURL(BucketType.Collection, cleanedAddress)}
        count={count}
        alt={collection?.name ?? ''}
        title={
          collection
            ? `${collection?.name
                ?.charAt(0)
                .toUpperCase()}${collection?.name?.slice(1)}`
            : ''
        }
      />
    </div>
  );
};

export default CollectionInfoCard;
